import { __awaiter } from "tslib";
import apiClient, { getApiHeaders } from './apiClient';
import { postWithProxy } from './proxyAPI';
const searchCompaniesByName = (companyData) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield apiClient.post('/api/lusha-prospecting/companies', companyData, {
        headers: getApiHeaders(),
    });
    return data;
});
const searchEmployeesByCompany = (companyData) => __awaiter(void 0, void 0, void 0, function* () { return postWithProxy('/api/lusha-prospecting/employees', companyData); });
export { searchCompaniesByName, searchEmployeesByCompany };
